import { useEffect, useState } from 'react'
import { css } from '@emotion/react'
import TextField from '@mui/material/TextField'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment, { Moment } from 'moment'
import { comparisonOperatorConfigsByColType, DateOperator } from '@global/constants'
import { ColumnDataType } from '@global/types'
import { DISPLAY_FORMAT } from './config'
import { getDateString } from './utils'
import { t } from '@lingui/core/macro'

const datePicker = css`
  width: 325px;
  button {
    margin: 0;
  }
`

interface Props {
  filterIndex: number
  filterValue: string
  operator: DateOperator
  onChange: (idx: number) => (obj: { target: { value: string } }) => void
}

export const SelectDate = ({ filterIndex, filterValue, operator, onChange }: Props) => {
  const [date, setDate] = useState<Moment>(filterValue ? moment(filterValue) : moment())
  const [open, setOpen] = useState<boolean>(false)

  const operatorConfig = comparisonOperatorConfigsByColType[ColumnDataType.DATE][operator]
  const canHaveValue = Boolean(operatorConfig?.canHaveValueOperand())

  useEffect(() => {
    if (!operator) return

    const dateString = getDateString(operator, moment(date))
    onChange(filterIndex)({ target: { value: dateString } })
  }, [operator, filterIndex, date])

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        open={open}
        disabled={!canHaveValue}
        inputFormat={DISPLAY_FORMAT}
        value={date}
        label={t`Date`}
        onChange={(date, _) => {
          handleDateChange(date, operator)
        }}
        css={datePicker}
        renderInput={props => (
          <TextField variant="standard" id="date-filter" onClick={handleClick} {...props} />
        )}
      />
    </LocalizationProvider>
  )

  function handleClick(): void {
    if (!canHaveValue) return
    setOpen(true)
  }

  function handleDateChange(momentDate: Moment | null, operator: DateOperator): void {
    if (!momentDate) return

    const dateString = getDateString(operator, momentDate)

    setOpen(false)
    setDate(momentDate)
    onChange(filterIndex)({ target: { value: dateString } })
  }
}
